import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import PeriodosLogScreen from './screen';
import { PeriodosLogAdapter, PeriodosLogRequest } from '../../../../../../infraestructure/persistence/rest/PeriodosLogAdapter';
import { useNotifications} from '../../../../../../shared/hooks/Notifications';

export const PeriodosLogContainer = () => {

	const api = new PeriodosLogAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	let [ periodosLog, setPeriodosLog ] = useState<any>([]);
	let result: any;

	useEffect(() => {}, [ periodosLog ]);

	const getPeriodosLog = async (año:number, periodo:any) => {
		try {
			// var reqdata : PeriodosLogRequest=undefined;
			// reqdata.año=año;
			// reqdata.periodo = periodo;
			result = await api.ListarPeriodosLog({año: año,periodo:periodo});
			if(result.data && result.data!=="")
			{
				setPeriodosLog([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	return (
		<>
			<PeriodosLogScreen data={periodosLog} onFilter={getPeriodosLog}/>
		</>
	);
};

export default PeriodosLogContainer;